import { Injectable, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import Swal from 'sweetalert2';

@Injectable()
export abstract class BaseFormComponent implements OnInit {
	form: UntypedFormGroup = new UntypedFormGroup({});

	constructor() {}

	ngOnInit() {}

	abstract submit(): void;

	onSubmit(): void {
		console.log('Form value =>', this.form.value);
		console.log('Invalid fields =>', this.findInvalidControls());
		if (this.form.valid) {
			this.submit();
		} else {
			Swal.fire({
				title: '¡Atención!',
				html: `<div>Verifique los campos obligatorios del formulario e inténtelo nuevamente.</div>`,
				icon: 'error',
				confirmButtonText: 'Ok',
				buttonsStyling: false,
				customClass: {
					confirmButton: 'btn btn-primary',
				},
			}).then(_ => {
				this.verifyFormValidations(this.form);
			});
		}
	}

	// public atLeastOneFilledExcept(exceptions: string[]): ValidatorFn {
	// 	return (formGroup: AbstractControl): { [key: string]: any } | null => {
	// 		if (formGroup instanceof FormGroup) {
	// 			const controls = formGroup.controls;

	// 			const fields = Object.keys(controls).filter(field => !exceptions.includes(field));

	// 			const anyFieldFilled = fields.some(field => formGroup.get(field)?.value);

	// 			if (anyFieldFilled) {
	// 				const allFieldsFilled = fields.every(field => !!formGroup.get(field)?.value);
	// 				return allFieldsFilled ? null : { atLeastOneFilled: true };
	// 			}
	// 		}

	// 		return null;
	// 	};
	// }

	public findInvalidControls() {
		const invalid = [];
		const controls = this.form.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		return invalid;
	}

	formatDate(date: any) {
		let newDate = new Date(date);
		let day = newDate.getDate() >= 0 && newDate.getDate() < 9 ? `0${newDate.getDate()}` : newDate.getDate();
		let month = newDate.getMonth() >= 0 && newDate.getMonth() < 8 ? `0${newDate.getMonth() + 1}` : `${newDate.getMonth() + 1}`;
		return `${day}/${month}/${newDate.getFullYear()}`;
	}

	verifyFormValidations(formGroup: UntypedFormGroup | UntypedFormArray | UntypedFormControl | string | any) {
		Object.keys(formGroup.controls).forEach(field => {
			const controle = formGroup.get(field);
			controle.markAsDirty();
			controle.markAsTouched();
			if (controle instanceof UntypedFormGroup || controle instanceof UntypedFormArray) {
				this.verifyFormValidations(controle);
			}
		});
	}

	reset(): void {
		this.form.reset();
	}

	verifyRequired(field: string) {
		return this.form.get(field)?.hasError('required') && (this.form.get(field)?.touched || this.form.get(field)?.dirty);
	}

	applyCssError(field: string, formGroup?: UntypedFormGroup): string {
		return this.verifyInvalidAndTouched(field, formGroup) ? 'is-invalid' : '';
	}

	verifyInvalidAndTouched(field: string, formGroup?: UntypedFormGroup) {
		return formGroup ? !formGroup.get(field)?.valid && (formGroup.get(field)?.touched || formGroup.get(field)?.dirty) : !this.form.get(field)?.valid && (this.form.get(field)?.touched || this.form.get(field)?.dirty);
	}

	verifyInvalidAndTouchedArray(arrayName: string, field: string, index: number) {
		let formArray = this.form.get(arrayName) as UntypedFormArray;

		return !formArray.controls[index].get(field)?.valid && (formArray.controls[index].get(field)?.touched || formArray.controls[index].get(field)?.dirty);
	}

	disableField(field: string): void {
		Object.keys(this.form.value).forEach(prop => {
			if (prop === field) {
				this.form.get(prop)?.disable();
			}
		});
	}

	enableField(field: string): void {
		Object.keys(this.form.value).forEach(prop => {
			if (prop === field) {
				this.form.get(prop)?.enable();
			}
		});
	}

	formatNullOrBooleanValues(form: UntypedFormGroup): UntypedFormGroup {
		for (const key in this.form.value) {
			if (this.form.controls[key].value === '') {
				this.form.controls[key].setValue(null);
			}

			if (this.form.controls[key].value === 'null') {
				this.form.controls[key].setValue(null);
			}

			if (this.form.controls[key].value === 'true') {
				this.form.controls[key].setValue(true);
			}

			if (this.form.controls[key].value === 'false') {
				this.form.controls[key].setValue(false);
			}
		}

		return form;
	}
}
